import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { Image } from '@/components/atoms/Image/Image'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { HeroIntegrationsTypes } from './types'

export function HeroIntegrations({
  heading,
  subheading,
  bg_image_left,
  bg_image_right,
  bg_image_mobile
}: HeroIntegrationsTypes) {
  return (
    <section
      className="relative mx-auto max-w-screen-desktop overflow-hidden flex flex-col items-center py-24 netbook:py-64"
      id={heading ? kebabCase(heading) : ''}
    >
      <div className="relative w-full flex justify-center items-center">
        <div className="px-24 netbook:px-0 flex flex-col justify-center min-h-[216px] tablet:max-w-38 netbook:max-w-52 text-center z-10 bg-gradient-to-r from-transparent via-white via-[percentage:10%_90%] to-transparent mb-32 tablet:mb-0">
          <h1 className="text-headingL-mobile tablet:text-headingL font-bold mb-16 font-poppins text-text-dark-900 text-balance">
            {heading}
          </h1>
          {subheading && <Paragraph className="text-bodyL text-text-dark-600 text-balance">{subheading}</Paragraph>}
        </div>
        {bg_image_left && bg_image_right && (
          <div className="absolute w-full top-1/2 -translate-y-1/2 justify-between hidden tablet:flex [mask:linear-gradient(to_right,_transparent_0%,_black_10%,_black_90%,_transparent_100%)]">
            <Image
              fixed={false}
              fluid
              data={bg_image_left}
              loading="eager"
              className="object-contain"
              imgClassName="max-w-full"
            />
            <Image
              fixed={false}
              fluid
              data={bg_image_right}
              loading="eager"
              className="object-contain"
              imgClassName="max-w-full"
            />
          </div>
        )}
      </div>
      {bg_image_mobile && (
        <Image
          fixed={false}
          fluid
          data={bg_image_mobile}
          loading="eager"
          className="object-contain tablet:hidden block w-full"
          imgClassName="w-full"
        />
      )}
    </section>
  )
}
